import { render, staticRenderFns } from "./BaseNotificationGlobal.vue?vue&type=template&id=edb88862&scoped=true&"
import script from "./BaseNotificationGlobal.vue?vue&type=script&lang=js&"
export * from "./BaseNotificationGlobal.vue?vue&type=script&lang=js&"
import style0 from "./BaseNotificationGlobal.vue?vue&type=style&index=0&id=edb88862&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb88862",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('edb88862')) {
      api.createRecord('edb88862', component.options)
    } else {
      api.reload('edb88862', component.options)
    }
    module.hot.accept("./BaseNotificationGlobal.vue?vue&type=template&id=edb88862&scoped=true&", function () {
      api.rerender('edb88862', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BaseNotificationGlobal.vue"
export default component.exports